import React, { Component } from 'react';
import { connect } from 'react-redux';
import Section from './section';
import { isEmpty as _isEmpty } from 'underscore';
import Linkify from 'linkify-react';

import { CommaList } from 'js/portfolio/components/comma_list';
import { Visible } from 'js/portfolio/components/visible';
import { Affiliation } from './affiliation';

class Home extends Component {
  constructor(props) {
    super(props);
    this.previewMessages = {
      biography:
        'Once you add a biography to your Academia.edu profile page, it will be automatically added here.',
      researchInterests:
        'Once you add research interests to your Academia.edu profile page, they will be automatically added here',
      affiliations:
        'Once you add affiliations to your Academia.edu profile page, they will be automatically added here.',
    };
  }

  render() {
    const { props, previewMessages } = this;

    return (
      <div>
        <Visible modes={0}>{this.renderBiography(props.biography)}</Visible>
        <Visible modes={(m) => m > 0}>
          {this.renderBiography(props.biography || previewMessages.biography)}
        </Visible>

        <Visible modes={0}>
          {this.renderResearchInterests(props.researchInterests)}
        </Visible>
        <Visible modes={(m) => m > 0}>
          {this.renderResearchInterests(
            props.researchInterests || [
              { display_name: previewMessages.researchInterests },
            ],
          )}
        </Visible>

        <Visible modes={0}>
          {this.renderAffiliations(props.affiliations)}
        </Visible>
        <Visible modes={(m) => m > 0}>
          {this.renderAffiliations(
            props.affiliations || [
              { placeholder: previewMessages.affiliations },
            ],
          )}
        </Visible>
      </div>
    );
  }

  renderBiography(biography) {
    if (!biography || !biography.length) return null;

    return (
      <Section header="Biography">
        {biography
          .split(/\n(\r)*/)
          .filter((a) => a !== undefined)
          .map((para, index) => (
            <span key={index}>
              <Linkify>{para}</Linkify>
              <br />
            </span>
          ))}
      </Section>
    );
  }

  renderResearchInterests(researchInterests) {
    if (!researchInterests || !researchInterests.length) return null;

    return (
      <Section header="Research Interests">
        <CommaList
          noShrink
          list={researchInterests.map(({ display_name }) => display_name)}
        />
      </Section>
    );
  }

  renderAffiliations(affiliations) {
    if (!affiliations || !affiliations.length) return null;

    return (
      <Section header="Affiliations">
        {affiliations.map((affiliation, index) => (
          <Affiliation key={index} affiliation={affiliation} />
        ))}
      </Section>
    );
  }
}

const mapStateToProps = (state) => {
  return Object.assign(
    {},
    !_isEmpty(state.user_info.biography) && {
      biography: state.user_info.biography,
    },
    !_isEmpty(state.user_info.research_interests) && {
      researchInterests: state.user_info.research_interests,
    },
    !_isEmpty(state.user_info.all_affiliations) && {
      affiliations: state.user_info.all_affiliations,
    },
  );
};

Home.defaultProps = {};

export default connect(mapStateToProps)(Home);
